module.exports = __webpack_public_path__ + "ca50bc293bf3e82d741565f2aba650ba.png";